import { render, staticRenderFns } from "./admin-alert-details-dialog.vue?vue&type=template&id=6c646dc5&scoped=true&"
import script from "./admin-alert-details-dialog.vue?vue&type=script&lang=js&"
export * from "./admin-alert-details-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c646dc5",
  null
  
)

export default component.exports